export default {
  methods: {
    // 获取公共埋点字段
    getBuryPointCommonParams(data) {
      const { productParam, mainProductInfo } = data || {}
      const { productId, productName, zljProductId } = productParam || {}
      const { productName: mainProductInfoProductName } = mainProductInfo || {}

      return {
        zz_goods_id: productId,
        goods_name: productName || mainProductInfoProductName,
        goods_id: zljProductId || productId,
      }
    },

    buryPointSend(event, params) {
      this.$emit('burypoint', {
        event,
        params,
      })
    },

    onBurypoint(event) {
      this.$emit('burypoint', event)
    },
  },
}
